import axios from 'axios'
import isNil from 'lodash.isnil'
import { getApiAddress, logError } from './helpers'
import BrokerService from './broker-service'
import store from 'src/app/store'
import { setSendingData } from 'src/modules/App/actions'

export const axiosInstance = axios.create({})

// NOTE: If there is an error here, it's probably something in `src/utils/helpers`
// since this is the first place where function is used from that helper
const apiUrl = getApiAddress()
const mockUrl = getApiAddress(true)

const apiConstructor = ({
  base = null,
  mock = false,
  id = null,
  query = null,
  page = null,
  limit = null,
  overrideUrl = null,
}) => {
  try {
    let fullUrl = ''
    let urlAdditions = []

    if (overrideUrl) {
      return overrideUrl
    }

    // Make sure the base is actually a valid element
    if (!isNil(base)) {
      fullUrl = fullUrl.concat(base)
    } else {
      throw new Error('Bad Url')
    }

    // Add an id to the request
    if (!isNil(id)) {
      fullUrl = fullUrl.concat('/', id)
    }

    // Add a query to the request
    if (query && query.length > 0) {
      query.forEach(q => {
        if (
          q.hasOwnProperty('name') &&
          q.hasOwnProperty('value') &&
          q.value &&
          q.value.length > 0
        ) {
          urlAdditions.push(`${q.name}=${q.value}`)
        }
      })
    }

    // Add a page number to the request
    if (!isNil(page)) {
      urlAdditions.push(`page=${page}`)
    }

    // Add limit to the request
    if (!isNil(limit)) {
      urlAdditions.push(`limit=${limit}`)
    }

    if (!mock) {
      urlAdditions.push(`broker=${BrokerService.getBroker()}`)
    }

    // Add the additional requst modifiers to the end of the url
    if (urlAdditions.length > 0) {
      fullUrl = fullUrl.concat('?', urlAdditions.join('&'))
    }

    if (mock) {
      return mockUrl.concat(fullUrl)
    }

    return apiUrl.concat(fullUrl)
  } catch (e) {
    logError('API Constructor', e)
    return apiUrl
  }
}

export function getPlain(params) {
  return new Promise((resolve, reject) => {
    store.dispatch(setSendingData(true))
    return axiosInstance
      .get(params)
      .then(response => {
        store.dispatch(setSendingData(false))
        resolve(response)
      })
      .catch(error => {
        store.dispatch(setSendingData(false))
        reject(error)
      })
  })
}

export function getRequest(params, options) {
  return new Promise((resolve, reject) => {
    store.dispatch(setSendingData(true))
    axiosInstance
      .get(apiConstructor(params), options)
      .then(response => {
        store.dispatch(setSendingData(false))
        resolve(response)
      })
      .catch(error => {
        store.dispatch(setSendingData(false))
        reject(error)
      })
  })
}

export function postRequest(params, data, options, isPlain = false) {
  return new Promise((resolve, reject) => {
    store.dispatch(setSendingData(true))
    const postParams = isPlain === true ? params : apiConstructor(params)
    axiosInstance
      .post(postParams, data, options)
      .then(response => {
        store.dispatch(setSendingData(false))
        resolve(response)
      })
      .catch(error => {
        store.dispatch(setSendingData(false))
        reject(error)
      })
  })
}

export function putRequest(params, data) {
  return new Promise((resolve, reject) => {
    store.dispatch(setSendingData(true))
    axiosInstance
      .put(apiConstructor(params), data)
      .then(response => {
        store.dispatch(setSendingData(false))
        resolve(response)
      })
      .catch(error => {
        store.dispatch(setSendingData(false))
        reject(error)
      })
  })
}

export function deleteRequest(params, options) {
  return new Promise((resolve, reject) => {
    store.dispatch(setSendingData(true))
    axiosInstance
      .delete(apiConstructor(params), options)
      .then(response => {
        store.dispatch(setSendingData(false))
        resolve(response)
      })
      .catch(error => {
        store.dispatch(setSendingData(false))
        reject(error)
      })
  })
}
